import React from 'react';

import Image from '@app/components/image';
import { Cast } from '@app/types/movie';

import { CastsStyled, CastStyled } from './casts-styled';

type CastsProps = {
  title?: string;
  cast: Array<Cast>;
};

const CastComponent = ({ title = '', cast }: CastsProps): JSX.Element => {
  return (
    <CastsStyled>
      <h2>{title}</h2>
      <div className="grid xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6 mb-24">
        {cast.map((castItem) => (
          <CastStyled key={castItem.uid}>
            <div className="cast-placeholder absolute">
              <Image
                src="/assets/images/image-generic-profile.jpg"
                width="80"
                height="80"
                layout="fixed"
                objectFit="cover"
                className="cast-image"
                loading="eager"
              />
            </div>
            {castItem?.photo?.url ? (
              <Image
                className="cast-image"
                src={castItem?.photo?.url}
                width="80"
                height="80"
                layout="fixed"
                objectFit="cover"
                loading="eager"
              />
            ) : (
              <Image
                className="cast-image"
                src="/assets/images/image-generic-profile.jpg"
                width="80"
                height="80"
                layout="fixed"
                objectFit="cover"
                loading="eager"
              />
            )}
            <div className="cast-details">
              <h4>{castItem.castName}</h4>
              <p>{castItem.characterName}</p>
            </div>
          </CastStyled>
        ))}
      </div>
    </CastsStyled>
  );
};

export default CastComponent;
